//
// Tailwind Toggles
// --------------------------------------------------
// Updates a data-open attribute on target classes when a target element is clicked
// this attribute can be targeted with tailwind styles to display as required
// Toggle once option available for things only wanting to fire once

window.addEventListener('load', () => {
    let twToggleContainers = document.querySelectorAll('[data-tw-toggle-container][data-open], [data-tw-toggle-container][data-open-once]');
    let twToggleElements = document.querySelectorAll('[data-tw-toggle-element][data-open], [data-tw-toggle-element][data-open-once]');

    for (let twToggleContainer of twToggleContainers) {
        let toggles = twToggleContainer.querySelectorAll('[data-tw-toggle]');

        for (let toggle of toggles) {
            toggle.addEventListener('click', () => {
                if (twToggleContainer.hasAttribute('data-open')) {
                    twToggleContainer.dataset.open === 'false'
                        ? (twToggleContainer.dataset.open = 'true')
                        : (twToggleContainer.dataset.open = 'false');
                }
                if (twToggleContainer.hasAttribute('data-open-once') && twToggleContainer.dataset.openOnce === 'false') {
                    (twToggleContainer.dataset.openOnce = 'true');
                }
            });
        }
    }

    for (let toggle of twToggleElements) {
        toggle.addEventListener('click', () => {
            if (toggle.hasAttribute('data-open')) {
                toggle.dataset.open === 'false'
                    ? (toggle.dataset.open = 'true')
                    : (toggle.dataset.open = 'false');
            }
            if (toggle.hasAttribute('data-open-once') && toggle.dataset.openOnce === 'false') {
                (toggle.dataset.openOnce = 'true');
            }
        });
    }
});
